export class LogbookViewKey {
  static readonly LOGBOOK_ROOT = 'logbook/view/logbook-root';
  static readonly LOGBOOK_SUMMARY = 'logbook/view/logbook-summary';
}
